import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { ScrollText, LineChart } from 'lucide-react';
import { ROUTES } from '../../utils/constants';
import { adm } from './adminTheme';

const nav = [
  { to: ROUTES.ADMIN_LOGS, label: 'Logs', icon: ScrollText },
  { to: ROUTES.ADMIN_METRICS, label: 'App Metrics', icon: LineChart },
];

export const AdminPanelShell: React.FC = () => {
  return (
    <div className="flex flex-col gap-8 lg:flex-row lg:gap-10 lg:items-start">
      <aside className="w-full shrink-0 lg:sticky lg:top-24 lg:w-[220px]">
        <div className={adm.rail}>
          <p className={adm.railLabel}>Workspace</p>
          <nav className="flex flex-row gap-1 overflow-x-auto pb-2 lg:flex-col lg:overflow-visible lg:pb-0">
            {nav.map(({ to, label, icon: Icon }) => (
              <NavLink
                key={to}
                to={to}
                end={to === ROUTES.ADMIN_LOGS}
                className={({ isActive }) =>
                  `${adm.navItem} ${isActive ? adm.navActive : adm.navInactive}`
                }
              >
                <Icon className={`${adm.navIcon} ${'transition-transform group-hover:scale-105'}`} />
                <span>{label}</span>
              </NavLink>
            ))}
          </nav>
        </div>
      </aside>
      <div className="min-w-0 flex-1 lg:min-h-[calc(100vh-8rem)]">
        <Outlet />
      </div>
    </div>
  );
};
